{
  "version": 1,
  "asset_id": "cd0fcc1c-a32f-4ed1-b84e-8ec3fe12483f",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/cd0fcc1c-a32f-4ed1-b84e-8ec3fe12483f/hero-music-on-poster.jpg",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/cd0fcc1c-a32f-4ed1-b84e-8ec3fe12483f/hero-music-on-poster.jpg",
  "original_filename": "hero-music-on-poster.jpg",
  "size": 6982,
  "content_type": "image/jpeg",
  "created_at": "2026-11-04T13:09:21Z"
}
